import React from "react";
import {IEvent} from "../../../../../models/Event";
import {PrizeDetails} from "./components/prizeTable/PrizeDetails";

export const Prize: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="resaluts-container">
            <h2 className="panel-title">פרסים</h2>
            {event.heats.map((heat,index) =>
                !!heat.prizes?.length &&
                <div key={index} className="prize-group">
                    <h3 className="panel-subtitle">{heat.description}</h3>
                    <PrizeDetails prizes={heat.prizes}/>
                </div>
            )}
        </div >
    )
}
